module.exports = __webpack_public_path__ + "media/images/live_chat_icon-f2974d8d.png";